/**
 * Page title for the allocations page
 */
export const PAGE_TITLE = 'Alocações do Colaborador';

/**
 * Placeholder message explaining incremental development
 */
export const PLACEHOLDER_MESSAGE =
  'Esta página será desenvolvida incrementalmente para gerenciar as alocações do colaborador em projetos e períodos.';

/**
 * Container styles for the page
 */
export const CONTAINER_STYLES = 'container mx-auto px-4 py-6 md:px-6 md:py-8';
